export { default as GenericSubjectType } from './GenericSubjectType'
export { default as PersonSubjectType } from './PersonSubjectType'
export * from './ISubjectType'
